import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../App";
import { toast } from "sonner";
import { Lock, Eye, EyeOff, GraduationCap } from "lucide-react";

const LOGO_URL = "/logo-gv.png";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(password);
    setLoading(false);
    if (res.success) {
      toast.success("Accesso effettuato");
      navigate("/dashboard");
    } else {
      setError(res.message || "Errore, riprova");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 pt-24 pb-10" data-testid="login-page">
      <div className="glass-card w-full max-w-md p-6 sm:p-8" style={{ borderColor: "rgba(47,216,168,0.3)" }} data-testid="login-card">
        <img src={LOGO_URL} alt="GoldVision Logo" className="w-24 h-24 object-contain mx-auto mb-4" data-testid="login-logo" />
        <h1 className="text-2xl sm:text-3xl font-bold text-center gold-text mb-1" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          GOLDVISION
        </h1>
        <p className="text-center text-sm mb-6" style={{ color: "var(--mm-text-secondary)" }}>
          Inserisci la password di accesso
        </p>

        <form onSubmit={submit} className="space-y-4">
          <div className="relative">
            <Lock size={18} className="absolute left-3 top-1/2 -translate-y-1/2" style={{ color: "var(--mm-text-muted)" }} />
            <input type={showPwd ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full pl-10 pr-12 py-3 rounded-lg text-sm outline-none focus:border-teal-400 transition-colors"
              style={{ backgroundColor: "var(--mm-surface)", border: "1px solid var(--mm-border)", color: "var(--mm-text-primary)" }}
              placeholder="Password" required data-testid="password-input" />
            <button type="button" onClick={() => setShowPwd(!showPwd)} className="absolute right-3 top-1/2 -translate-y-1/2" data-testid="toggle-password-visibility">
              {showPwd ? <EyeOff size={18} style={{ color: "var(--mm-text-muted)" }} /> : <Eye size={18} style={{ color: "var(--mm-text-muted)" }} />}
            </button>
          </div>

          {error && (
            <p className="text-sm text-center" style={{ color: "#EF4444" }} data-testid="auth-error">{error}</p>
          )}

          <button type="submit" disabled={loading}
            className="w-full py-3.5 rounded-lg font-bold uppercase text-sm transition-all duration-300 hover:scale-[1.01]"
            style={{ fontFamily: "'Space Grotesk', sans-serif", letterSpacing: "0.08em", background: "linear-gradient(135deg, #2FD8A8 0%, #1FB489 100%)", color: "#0A0A0A", opacity: loading ? 0.6 : 1 }}
            data-testid="login-submit-btn">
            {loading ? "Attendere..." : "Accedi"}
          </button>
        </form>

        <div className="flex items-center gap-3 my-6">
          <div className="flex-1 h-px" style={{ backgroundColor: "var(--mm-border)" }} />
          <span className="text-xs" style={{ color: "var(--mm-text-muted)" }}>oppure</span>
          <div className="flex-1 h-px" style={{ backgroundColor: "var(--mm-border)" }} />
        </div>

        <Link to="/diventa-studente" className="flex items-center justify-center gap-3 w-full py-3 rounded-lg transition-all hover:bg-white/5"
          style={{ border: "1px solid var(--mm-border)", color: "var(--mm-text-primary)", textDecoration: "none" }} data-testid="diventa-studente-btn">
          <span className="w-8 h-8 rounded-full flex items-center justify-center" style={{ backgroundColor: "rgba(47,216,168,0.15)" }}>
            <GraduationCap size={15} style={{ color: "var(--mm-gold)" }} />
          </span>
          <span className="text-sm font-semibold">Diventa Studente</span>
        </Link>
      </div>
    </div>
  );
}
